import RegularText from '@/components/RegularText';
import { DateChoicesEnum, FrequencyEnum, WeekdayEnum } from '@/constants/enum';
import {
  handleSavePickupWeeklyWorkingDays,
  pickupSettingSelector,
  pickupWeeklyWorkingDaySelector,
} from '@/redux/slice/pickup.slice';
import { IWeeklyWorkingDay } from '@/types/components/day';
import { BlockStack, Box, InlineGrid, Select } from '@shopify/polaris';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const CopySetup = ({
  selectTabDays,
  selectedWorkingDay,
}: {
  selectTabDays: number;
  selectedWorkingDay?: IWeeklyWorkingDay;
}) => {
  const pickupSettings = useSelector(pickupSettingSelector);
  const pickupWeeklyWorkingDays = useSelector(pickupWeeklyWorkingDaySelector);
  const { t } = useTranslation('pickupSettings');
  const dispatch = useDispatch();

  const [dayToCopy, setDayToCopy] = useState<string>('');

  const copyOptionList = useMemo(() => {
    return [
      { label: t('weekDaysLong.1'), value: WeekdayEnum.MONDAY.toString() },
      { label: t('weekDaysLong.2'), value: WeekdayEnum.TUESDAY.toString() },
      { label: t('weekDaysLong.3'), value: WeekdayEnum.WEDNESDAY.toString() },
      { label: t('weekDaysLong.4'), value: WeekdayEnum.THURSDAY.toString() },
      { label: t('weekDaysLong.5'), value: WeekdayEnum.FRIDAY.toString() },
      { label: t('weekDaysLong.6'), value: WeekdayEnum.SATURDAY.toString() },
      { label: t('weekDaysLong.0'), value: WeekdayEnum.SUNDAY.toString() },
    ]
      .filter((item) => pickupWeeklyWorkingDays.find((day) => day.day === parseInt(item.value))?.isEnable)
      .filter((item) => item.value !== selectedWorkingDay?.day.toString());
  }, [pickupWeeklyWorkingDays, selectedWorkingDay?.day, t]);

  const handleCopy = (value: string) => {
    setDayToCopy(value);
    const day = parseInt(value);
    const dayToCopyData = pickupWeeklyWorkingDays.find((item) => item.day === day);

    if (dayToCopyData) {
      dispatch(
        handleSavePickupWeeklyWorkingDays(
          pickupWeeklyWorkingDays.map((item) => {
            if (item.day === selectedWorkingDay?.day) {
              return {
                ...item,
                pickupFrequency: dayToCopyData.pickupFrequency,
                workingHours:
                  dayToCopyData.pickupFrequency !== FrequencyEnum.CUSTOM ? dayToCopyData.workingHours : item.workingHours,
                exactTimes: pickupSettings.pickupChoice === DateChoicesEnum.DATETIME ? dayToCopyData.exactTimes : item.exactTimes,
                timeSlots:
                  pickupSettings.pickupChoice === DateChoicesEnum.DATETIMESLOT ? dayToCopyData.timeSlots : item.timeSlots,
              };
            }
            return item;
          }),
        ),
      );
    }
  };

  useEffect(() => {
    setDayToCopy('');
  }, [selectTabDays]);

  return (
    <Box paddingBlock={'200'}>
      <InlineGrid columns={'1fr auto'} gap={'300'} alignItems="end">
        <BlockStack gap={'100'}>
          <RegularText as="p">{t('pickupTime.copyLabel')}</RegularText>
          <Select
            label=""
            placeholder="Select one"
            options={copyOptionList}
            onChange={(value) => handleCopy(value)}
            value={dayToCopy}
          />
        </BlockStack>
      </InlineGrid>
    </Box>
  );
};

export default CopySetup;
